import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// The app's CallRoom keys (token / presence / media / moderation actions, participant fields), passed to the
// engine CallRoom unchanged: they wire the call to the app's entities, not to the design.
export default class CallRoomWiring extends BaseOption {
  static userInterfaceComponent = {
    component: inspectorTools.NONE,
  };

  static defaultValue = {};
}
